<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Approve {{ $term('positionDescription', { case: 'title' }) }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<div class="pt-3 pb-2">Please confirm that you want to approve this {{ $term('positionDescription') }}.</div>
				<div class="mt-3 disclaimer">
					<span v-if="requireEmployeeAcknowledgement">The {{ $term('employee') }} will also have to acknowledge the {{ $term('positionDescription') }} before it becomes live. This can only be done after approval.</span>
					<span v-else>This {{ $term('positionDescription') }} will become live immediately. The {{ $term('employee') }} will not be asked to acknowledge it.</span>
				</div>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<v-btn :disabled="isApproving" flat @click="onCancel">Cancel</v-btn>
				<v-btn :disabled="isApproving" :loading="isApproving" color="primary" flat @click="onApprove">Approve <span slot="loader">Please Wait...</span></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			isApproving: {
				type: Boolean,
				required: false
			},
			requireEmployeeAcknowledgement: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {};
		},
		methods: {
			onApprove() {
				this.$emit('onApprove');
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>

<style scoped>
	.disclaimer {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
	}
</style>
